/* tslint:disable */
/* eslint-disable */
/**
 * Happyforce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EmployeeSendReminderRequest } from '../models';
// @ts-ignore
import type { EmployeeTemplateType } from '../models';
// @ts-ignore
import type { EmployeeTurnOverTypes } from '../models';
// @ts-ignore
import type { ManagementFocus } from '../models';
// @ts-ignore
import type { PaginableGenericListResultPersonDTO } from '../models';
// @ts-ignore
import type { PersonDTO } from '../models';
// @ts-ignore
import type { PersonProfileDTO } from '../models';
/**
 * PeopleResourceApi - axios parameter creator
 * @export
 */
export const PeopleResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {string} [email] 
         * @param {string} [turnoverDate] 
         * @param {EmployeeTurnOverTypes} [turnoverType] 
         * @param {boolean} [regrettable] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePerson: async (id?: string, email?: string, turnoverDate?: string, turnoverType?: EmployeeTurnOverTypes, regrettable?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/company/people`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (turnoverDate !== undefined) {
                localVarQueryParameter['turnoverDate'] = (turnoverDate as any instanceof Date) ?
                    (turnoverDate as any).toISOString() :
                    turnoverDate;
            }

            if (turnoverType !== undefined) {
                localVarQueryParameter['turnoverType'] = turnoverType;
            }

            if (regrettable !== undefined) {
                localVarQueryParameter['regrettable'] = regrettable;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EmployeeTemplateType} templateType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadTemplate: async (templateType: EmployeeTemplateType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateType' is not null or undefined
            assertParamExists('downloadTemplate', 'templateType', templateType)
            const localVarPath = `/api/v1/company/people/template/{templateType}`
                .replace(`{${"templateType"}}`, encodeURIComponent(String(templateType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EngageInactivesTargetEnum} target 
         * @param {EmployeeSendReminderRequest} employeeSendReminderRequest 
         * @param {Set<string>} [hierarchyId] 
         * @param {string} [filters] 
         * @param {Set<string>} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        engageInactives: async (target: EngageInactivesTargetEnum, employeeSendReminderRequest: EmployeeSendReminderRequest, hierarchyId?: Set<string>, filters?: string, groupId?: Set<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'target' is not null or undefined
            assertParamExists('engageInactives', 'target', target)
            // verify required parameter 'employeeSendReminderRequest' is not null or undefined
            assertParamExists('engageInactives', 'employeeSendReminderRequest', employeeSendReminderRequest)
            const localVarPath = `/api/v1/company/people/reminder/{target}`
                .replace(`{${"target"}}`, encodeURIComponent(String(target)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)

            if (hierarchyId) {
                localVarQueryParameter['hierarchyId'] = Array.from(hierarchyId);
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = filters;
            }

            if (groupId) {
                localVarQueryParameter['groupId'] = Array.from(groupId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(employeeSendReminderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [from] 
         * @param {number} [to] 
         * @param {boolean} [activated] 
         * @param {boolean} [deleted] 
         * @param {Array<string>} [hierarchyId] 
         * @param {string} [filters] 
         * @param {Set<string>} [groupId] 
         * @param {string} [text] 
         * @param {GetEmployeesMailStatusEnum} [mailStatus] 
         * @param {Set<GetEmployeesRoleEnum>} [role] 
         * @param {Set<ManagementFocus>} [managementFocus] 
         * @param {GetEmployeesOrderByEnum} [orderBy] 
         * @param {boolean} [orderDesc] 
         * @param {boolean} [withoutArea] 
         * @param {boolean} [incompleteProfile] 
         * @param {boolean} [blocked] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployees: async (from?: number, to?: number, activated?: boolean, deleted?: boolean, hierarchyId?: Array<string>, filters?: string, groupId?: Set<string>, text?: string, mailStatus?: GetEmployeesMailStatusEnum, role?: Set<GetEmployeesRoleEnum>, managementFocus?: Set<ManagementFocus>, orderBy?: GetEmployeesOrderByEnum, orderDesc?: boolean, withoutArea?: boolean, incompleteProfile?: boolean, blocked?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/company/people/find`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }

            if (activated !== undefined) {
                localVarQueryParameter['activated'] = activated;
            }

            if (deleted !== undefined) {
                localVarQueryParameter['deleted'] = deleted;
            }

            if (hierarchyId) {
                localVarQueryParameter['hierarchyId'] = hierarchyId;
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = filters;
            }

            if (groupId) {
                localVarQueryParameter['groupId'] = Array.from(groupId);
            }

            if (text !== undefined) {
                localVarQueryParameter['text'] = text;
            }

            if (mailStatus !== undefined) {
                localVarQueryParameter['mailStatus'] = mailStatus;
            }

            if (role) {
                localVarQueryParameter['role'] = Array.from(role);
            }

            if (managementFocus) {
                localVarQueryParameter['managementFocus'] = Array.from(managementFocus);
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDesc !== undefined) {
                localVarQueryParameter['orderDesc'] = orderDesc;
            }

            if (withoutArea !== undefined) {
                localVarQueryParameter['withoutArea'] = withoutArea;
            }

            if (incompleteProfile !== undefined) {
                localVarQueryParameter['incompleteProfile'] = incompleteProfile;
            }

            if (blocked !== undefined) {
                localVarQueryParameter['blocked'] = blocked;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [email] 
         * @param {string} [externalId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPerson: async (id?: string, email?: string, externalId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/company/people`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (externalId !== undefined) {
                localVarQueryParameter['externalId'] = externalId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonProfile: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPersonProfile', 'id', id)
            const localVarPath = `/api/v1/company/people/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PersonDTO} personDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitePerson: async (personDTO: PersonDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'personDTO' is not null or undefined
            assertParamExists('invitePerson', 'personDTO', personDTO)
            const localVarPath = `/api/v1/company/people`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(personDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendInvite: async (id?: string, email?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/company/people/resendInvite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resubscribeToEmail: async (id?: string, email?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/company/people/resubscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PersonDTO} personDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePerson: async (personDTO: PersonDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'personDTO' is not null or undefined
            assertParamExists('updatePerson', 'personDTO', personDTO)
            const localVarPath = `/api/v1/company/people`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(personDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PeopleResourceApi - functional programming interface
 * @export
 */
export const PeopleResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PeopleResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {string} [email] 
         * @param {string} [turnoverDate] 
         * @param {EmployeeTurnOverTypes} [turnoverType] 
         * @param {boolean} [regrettable] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePerson(id?: string, email?: string, turnoverDate?: string, turnoverType?: EmployeeTurnOverTypes, regrettable?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePerson(id, email, turnoverDate, turnoverType, regrettable, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PeopleResourceApi.deletePerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EmployeeTemplateType} templateType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadTemplate(templateType: EmployeeTemplateType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadTemplate(templateType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PeopleResourceApi.downloadTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EngageInactivesTargetEnum} target 
         * @param {EmployeeSendReminderRequest} employeeSendReminderRequest 
         * @param {Set<string>} [hierarchyId] 
         * @param {string} [filters] 
         * @param {Set<string>} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async engageInactives(target: EngageInactivesTargetEnum, employeeSendReminderRequest: EmployeeSendReminderRequest, hierarchyId?: Set<string>, filters?: string, groupId?: Set<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.engageInactives(target, employeeSendReminderRequest, hierarchyId, filters, groupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PeopleResourceApi.engageInactives']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [from] 
         * @param {number} [to] 
         * @param {boolean} [activated] 
         * @param {boolean} [deleted] 
         * @param {Array<string>} [hierarchyId] 
         * @param {string} [filters] 
         * @param {Set<string>} [groupId] 
         * @param {string} [text] 
         * @param {GetEmployeesMailStatusEnum} [mailStatus] 
         * @param {Set<GetEmployeesRoleEnum>} [role] 
         * @param {Set<ManagementFocus>} [managementFocus] 
         * @param {GetEmployeesOrderByEnum} [orderBy] 
         * @param {boolean} [orderDesc] 
         * @param {boolean} [withoutArea] 
         * @param {boolean} [incompleteProfile] 
         * @param {boolean} [blocked] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployees(from?: number, to?: number, activated?: boolean, deleted?: boolean, hierarchyId?: Array<string>, filters?: string, groupId?: Set<string>, text?: string, mailStatus?: GetEmployeesMailStatusEnum, role?: Set<GetEmployeesRoleEnum>, managementFocus?: Set<ManagementFocus>, orderBy?: GetEmployeesOrderByEnum, orderDesc?: boolean, withoutArea?: boolean, incompleteProfile?: boolean, blocked?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginableGenericListResultPersonDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployees(from, to, activated, deleted, hierarchyId, filters, groupId, text, mailStatus, role, managementFocus, orderBy, orderDesc, withoutArea, incompleteProfile, blocked, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PeopleResourceApi.getEmployees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [email] 
         * @param {string} [externalId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPerson(id?: string, email?: string, externalId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPerson(id, email, externalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PeopleResourceApi.getPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersonProfile(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonProfileDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersonProfile(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PeopleResourceApi.getPersonProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PersonDTO} personDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitePerson(personDTO: PersonDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitePerson(personDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PeopleResourceApi.invitePerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendInvite(id?: string, email?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendInvite(id, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PeopleResourceApi.resendInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resubscribeToEmail(id?: string, email?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resubscribeToEmail(id, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PeopleResourceApi.resubscribeToEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PersonDTO} personDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePerson(personDTO: PersonDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePerson(personDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PeopleResourceApi.updatePerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PeopleResourceApi - factory interface
 * @export
 */
export const PeopleResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PeopleResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {string} [email] 
         * @param {string} [turnoverDate] 
         * @param {EmployeeTurnOverTypes} [turnoverType] 
         * @param {boolean} [regrettable] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePerson(id?: string, email?: string, turnoverDate?: string, turnoverType?: EmployeeTurnOverTypes, regrettable?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PersonDTO> {
            return localVarFp.deletePerson(id, email, turnoverDate, turnoverType, regrettable, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmployeeTemplateType} templateType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadTemplate(templateType: EmployeeTemplateType, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadTemplate(templateType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EngageInactivesTargetEnum} target 
         * @param {EmployeeSendReminderRequest} employeeSendReminderRequest 
         * @param {Set<string>} [hierarchyId] 
         * @param {string} [filters] 
         * @param {Set<string>} [groupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        engageInactives(target: EngageInactivesTargetEnum, employeeSendReminderRequest: EmployeeSendReminderRequest, hierarchyId?: Set<string>, filters?: string, groupId?: Set<string>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.engageInactives(target, employeeSendReminderRequest, hierarchyId, filters, groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [from] 
         * @param {number} [to] 
         * @param {boolean} [activated] 
         * @param {boolean} [deleted] 
         * @param {Array<string>} [hierarchyId] 
         * @param {string} [filters] 
         * @param {Set<string>} [groupId] 
         * @param {string} [text] 
         * @param {GetEmployeesMailStatusEnum} [mailStatus] 
         * @param {Set<GetEmployeesRoleEnum>} [role] 
         * @param {Set<ManagementFocus>} [managementFocus] 
         * @param {GetEmployeesOrderByEnum} [orderBy] 
         * @param {boolean} [orderDesc] 
         * @param {boolean} [withoutArea] 
         * @param {boolean} [incompleteProfile] 
         * @param {boolean} [blocked] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployees(from?: number, to?: number, activated?: boolean, deleted?: boolean, hierarchyId?: Array<string>, filters?: string, groupId?: Set<string>, text?: string, mailStatus?: GetEmployeesMailStatusEnum, role?: Set<GetEmployeesRoleEnum>, managementFocus?: Set<ManagementFocus>, orderBy?: GetEmployeesOrderByEnum, orderDesc?: boolean, withoutArea?: boolean, incompleteProfile?: boolean, blocked?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginableGenericListResultPersonDTO> {
            return localVarFp.getEmployees(from, to, activated, deleted, hierarchyId, filters, groupId, text, mailStatus, role, managementFocus, orderBy, orderDesc, withoutArea, incompleteProfile, blocked, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [email] 
         * @param {string} [externalId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPerson(id?: string, email?: string, externalId?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonDTO> {
            return localVarFp.getPerson(id, email, externalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonProfile(id: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonProfileDTO> {
            return localVarFp.getPersonProfile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PersonDTO} personDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitePerson(personDTO: PersonDTO, options?: RawAxiosRequestConfig): AxiosPromise<PersonDTO> {
            return localVarFp.invitePerson(personDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendInvite(id?: string, email?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonDTO> {
            return localVarFp.resendInvite(id, email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resubscribeToEmail(id?: string, email?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonDTO> {
            return localVarFp.resubscribeToEmail(id, email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PersonDTO} personDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePerson(personDTO: PersonDTO, options?: RawAxiosRequestConfig): AxiosPromise<PersonDTO> {
            return localVarFp.updatePerson(personDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PeopleResourceApi - object-oriented interface
 * @export
 * @class PeopleResourceApi
 * @extends {BaseAPI}
 */
export class PeopleResourceApi extends BaseAPI {
    /**
     * 
     * @param {string} [id] 
     * @param {string} [email] 
     * @param {string} [turnoverDate] 
     * @param {EmployeeTurnOverTypes} [turnoverType] 
     * @param {boolean} [regrettable] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleResourceApi
     */
    public deletePerson(id?: string, email?: string, turnoverDate?: string, turnoverType?: EmployeeTurnOverTypes, regrettable?: boolean, options?: RawAxiosRequestConfig) {
        return PeopleResourceApiFp(this.configuration).deletePerson(id, email, turnoverDate, turnoverType, regrettable, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmployeeTemplateType} templateType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleResourceApi
     */
    public downloadTemplate(templateType: EmployeeTemplateType, options?: RawAxiosRequestConfig) {
        return PeopleResourceApiFp(this.configuration).downloadTemplate(templateType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EngageInactivesTargetEnum} target 
     * @param {EmployeeSendReminderRequest} employeeSendReminderRequest 
     * @param {Set<string>} [hierarchyId] 
     * @param {string} [filters] 
     * @param {Set<string>} [groupId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleResourceApi
     */
    public engageInactives(target: EngageInactivesTargetEnum, employeeSendReminderRequest: EmployeeSendReminderRequest, hierarchyId?: Set<string>, filters?: string, groupId?: Set<string>, options?: RawAxiosRequestConfig) {
        return PeopleResourceApiFp(this.configuration).engageInactives(target, employeeSendReminderRequest, hierarchyId, filters, groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [from] 
     * @param {number} [to] 
     * @param {boolean} [activated] 
     * @param {boolean} [deleted] 
     * @param {Array<string>} [hierarchyId] 
     * @param {string} [filters] 
     * @param {Set<string>} [groupId] 
     * @param {string} [text] 
     * @param {GetEmployeesMailStatusEnum} [mailStatus] 
     * @param {Set<GetEmployeesRoleEnum>} [role] 
     * @param {Set<ManagementFocus>} [managementFocus] 
     * @param {GetEmployeesOrderByEnum} [orderBy] 
     * @param {boolean} [orderDesc] 
     * @param {boolean} [withoutArea] 
     * @param {boolean} [incompleteProfile] 
     * @param {boolean} [blocked] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleResourceApi
     */
    public getEmployees(from?: number, to?: number, activated?: boolean, deleted?: boolean, hierarchyId?: Array<string>, filters?: string, groupId?: Set<string>, text?: string, mailStatus?: GetEmployeesMailStatusEnum, role?: Set<GetEmployeesRoleEnum>, managementFocus?: Set<ManagementFocus>, orderBy?: GetEmployeesOrderByEnum, orderDesc?: boolean, withoutArea?: boolean, incompleteProfile?: boolean, blocked?: boolean, options?: RawAxiosRequestConfig) {
        return PeopleResourceApiFp(this.configuration).getEmployees(from, to, activated, deleted, hierarchyId, filters, groupId, text, mailStatus, role, managementFocus, orderBy, orderDesc, withoutArea, incompleteProfile, blocked, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {string} [email] 
     * @param {string} [externalId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleResourceApi
     */
    public getPerson(id?: string, email?: string, externalId?: string, options?: RawAxiosRequestConfig) {
        return PeopleResourceApiFp(this.configuration).getPerson(id, email, externalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleResourceApi
     */
    public getPersonProfile(id: string, options?: RawAxiosRequestConfig) {
        return PeopleResourceApiFp(this.configuration).getPersonProfile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PersonDTO} personDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleResourceApi
     */
    public invitePerson(personDTO: PersonDTO, options?: RawAxiosRequestConfig) {
        return PeopleResourceApiFp(this.configuration).invitePerson(personDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {string} [email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleResourceApi
     */
    public resendInvite(id?: string, email?: string, options?: RawAxiosRequestConfig) {
        return PeopleResourceApiFp(this.configuration).resendInvite(id, email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {string} [email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleResourceApi
     */
    public resubscribeToEmail(id?: string, email?: string, options?: RawAxiosRequestConfig) {
        return PeopleResourceApiFp(this.configuration).resubscribeToEmail(id, email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PersonDTO} personDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleResourceApi
     */
    public updatePerson(personDTO: PersonDTO, options?: RawAxiosRequestConfig) {
        return PeopleResourceApiFp(this.configuration).updatePerson(personDTO, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const EngageInactivesTargetEnum = {
    Sleeping: 'SLEEPING',
    NonActivated: 'NON_ACTIVATED'
} as const;
export type EngageInactivesTargetEnum = typeof EngageInactivesTargetEnum[keyof typeof EngageInactivesTargetEnum];
/**
 * @export
 */
export const GetEmployeesMailStatusEnum = {
    Correct: 'CORRECT',
    Unknown: 'UNKNOWN',
    Failing: 'FAILING',
    Unsubscribed: 'UNSUBSCRIBED'
} as const;
export type GetEmployeesMailStatusEnum = typeof GetEmployeesMailStatusEnum[keyof typeof GetEmployeesMailStatusEnum];
/**
 * @export
 */
export const GetEmployeesRoleEnum = {
    Advisor: 'ADVISOR',
    Admin: 'ADMIN',
    Responsible: 'RESPONSIBLE',
    Public: 'PUBLIC',
    Manager: 'MANAGER',
    Employee: 'EMPLOYEE'
} as const;
export type GetEmployeesRoleEnum = typeof GetEmployeesRoleEnum[keyof typeof GetEmployeesRoleEnum];
/**
 * @export
 */
export const GetEmployeesOrderByEnum = {
    Email: 'email',
    Name: 'name',
    AddedOn: 'addedOn',
    InvitedOn: 'invitedOn'
} as const;
export type GetEmployeesOrderByEnum = typeof GetEmployeesOrderByEnum[keyof typeof GetEmployeesOrderByEnum];
